// Fragment "receipts (B75)" — client portal purchases/receipts section
// (ClientPortal.jsx) and the checkout success receipt link (CheckoutSuccess.jsx).
// Fusionné dans ./index.js.
export default {
  fr: {
    "portal.receipts": "Achats et reçus",
    "portal.receiptView": "Voir le reçu",
    "checkout.viewReceipt": "Voir le reçu fiscal",
  },
  en: {
    "portal.receipts": "Purchases & receipts",
    "portal.receiptView": "View receipt",
    "checkout.viewReceipt": "View tax receipt",
  },
  es: {
    "portal.receipts": "Compras y recibos",
    "portal.receiptView": "Ver recibo",
    "checkout.viewReceipt": "Ver recibo fiscal",
  },
};
